import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { ConversationRoutes } from 'entities/ExportRouters'
import { checkAccessLandingMobilePage } from 'entities/ExportRouters/lib/checkAccessLandingMobilePage'

export const LandingMobileAccessLayout = observer(() => {
  const hasAccess = checkAccessLandingMobilePage()

  useEffect(() => {
    if (!hasAccess) {
      uiStore.changeRouteViaVue({ path: `/${ConversationRoutes.root}` })
    }
  }, [hasAccess])

  if (!hasAccess) return null

  return <Outlet />
})
